<script setup>
  import { useSession, route } from '@procommerce/visitor';
  import { ref } from 'vue';

  const session = useSession();
  const mouseOver = ref('');

</script>
<template>
  <div @mouseover="mouseOver = true" @mouseleave="mouseOver = false" class="action-item">
    <VisitorLink :href="session.is_authenticated ? route('web.account.show') : 'javascript:void(0)'" class="link">
      <IconPersonCircle />
    </VisitorLink>
    <Transition name="show">
      <HeaderAccountDetailsMini v-if="mouseOver && !session.is_authenticated" />
    </Transition>
  </div>
</template>
<style scoped lang="scss">
  .show-enter-from,
  .show-leave-to {
    opacity: 0;
  }

  .show-enter-active,
  .show-leave-active {
    transition: var(--transition-primary-popups);
  }

  .action-item {
    position: relative;
    height: 100%;

    &.scroll {
      .link {
        column-gap: 0;
      }
    }

    .link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.375rem;
      height: 100%;
      color: var(--color-main-black);

      &:hover {
        color: var(--primary-color-hover);
      }

      svg {
        font-size: 1.875rem;
      }
    }

    .link {
      transition-property: color;
      transition-duration: var(--transition-primary-duration);
      transition-timing-function: var(--transition-primary-timing-function);
    }
  }
</style>
